<div class="checkout-services">
  <div class="checkout-section-title">
    <h2 class="checkout-services-label text-b3-m-700 text-md-b1-s-700 text-lg-b1-m-700 color-black">услуги</h2>

    <sd-checkout-validation-error
      [errorKeys]="['SERVICE_REQUIRED', 'FLOOR_NOT_SPECIFIED']"
    ></sd-checkout-validation-error>
  </div>

  @if ((!isSuccess() && !isError()) || isLoading()) {
    <div class="checkout-services-list sd-group-skeleton-gradient-wave">
      @for (i of [].constructor(5); track $index) {
        <div class="checkout-services-list-item sd-skeleton"></div>
      }
    </div>
  } @else if (isError()) {
    <sd-system-message type="warning">
      {{ errorMessage }}
    </sd-system-message>
  } @else {
    <div class="checkout-services-list">
      @for (item of serviceItems(); track item.code) {
        <div class="checkout-services-list-item text-b3-s-300 text-lg-b4-m-300 color-black">
          <sd-radio [formControl]="radioControl" [value]="item.code" name="checkout-service">
            <div class="checkout-services-list-item-wrapper color-black">
              {{ item.title }}

              <!-- для пункта "курьер" хардкодим текст подсказки -->
              @if (item.code === 'COURIER') {
                <span class="color-black-600">| донесет до двери бесплатно</span>
              }
            </div>
          </sd-radio>

          @if (item.reason) {
            <div class="checkout-services-list-item-tooltip">
              <sd-icon
                [type]="iconTypes.ATTENTION"
                class="icon-size-s"
                #tooltip="ngbTooltip"
                [ngbTooltip]="tooltipContent"
              />

              <ng-template #tooltipContent>
                <span class="text-c1-l-300 color-black">менеджер уточнит возможность доставки</span>
              </ng-template>
            </div>
            <!-- для пункта "без услуг" цену не показываем -->
          } @else if (item.minPrice > 0 && item.code !== 'OTHER') {
            <div class="checkout-services-list-item-price">от {{ item.minPrice }} ₽</div>
          }
        </div>

        <!-- для пункта "манипулятор" хардкодим текст подсказки -->
        @if (item.code === 'MANIPULATOR' && activeOptionCode() === 'MANIPULATOR') {
          <span class="text-b3-s-500 text-lg-b4-m-500 color-black">необходим стропальщик со стороны клиента</span>
        }

        @if (item.code === 'LIFTING' && activeOptionCode() === 'LIFTING' && deliveryAddress()?.privateHouse !== true) {
          <sd-lifting-options></sd-lifting-options>
        }
      }
    </div>
  }
</div>
